import React from 'react';

function Footer(){
    return (
        <footer className="main-footer text-center">
        &copy; {(new Date()).getFullYear()} <a href="https://etyel.com" className='text-muted' target="_blank">Etyel ERP</a>
        </footer>
    )
}

export default Footer;
